// ═════════════════════════════════════════════════════════════════════
//  Settings demo seed — roles + stores + users from resources/build-4/database/
//  live.sql (build-4 production). Mirrors the exact legacy tables.
// ═════════════════════════════════════════════════════════════════════

export const rolesSeed = [
  { role_id: 1, role_type: 'super', role_name: 'System Administrator' },
  { role_id: 2, role_type: 'admin', role_name: 'Admin Toko' },
  { role_id: 3, role_type: 'purchasing', role_name: 'Purchasing User' },
  { role_id: 4, role_type: 'sales', role_name: 'Sales User' },
  { role_id: 5, role_type: 'marketing', role_name: 'Marketing' },
  { role_id: 6, role_type: 'finance', role_name: 'Finance' },
  { role_id: 7, role_type: 'debugger', role_name: 'Debugger' },
];

export const storesSeed = [
  {
    store_id: 1,
    store_name: 'Toko Seroja Makmur',
    store_desc: 'Home & Gadget Accessories',
    store_address:
      'Gedung Harco Glodok Jl. Hayam Wuruk No.2-5 Lt. GF 2 Blok B No. 63 Jakarta Barat 11180',
    store_phone: '085213872988',
    store_website: 'serojamakmur.com',
    store_logo: '/stores/1/logos/seroja-logo_alter.png',
    store_appicon: '/stores/1/logos/seroja-appicon.png',
  },
];

export const usersSeed = [
  { id: 1, store_id: 1, username: 'developer', name: 'Developer', email: 'dev@srjmkr.my.id', role: 1 },
  { id: 2, store_id: 1, username: 'dwi', name: 'Dwi', email: 'dwi@serojamakmur.com', role: 2 },
  { id: 3, store_id: 1, username: 'admin1', name: 'Debby', email: 'admin1@serojamakmur.com', role: 2 },
  { id: 4, store_id: 1, username: 'admin2', name: 'Bejo', email: 'admin2@serojamakmur.com', role: 3 },
  { id: 5, store_id: 1, username: 'widhi', name: 'Widhi', email: 'widhi@serojamakmur.com', role: 1 },
  { id: 6, store_id: 1, username: 'purchase', name: 'Purchase', email: 'ivone@serojamakmur.com', role: 3 },
  { id: 7, store_id: 1, username: 'debugger', name: 'Debugger', email: 'debugger@srjmkr.my.id', role: 7 },
];
